import Services from '../Service'

class CatalogoService extends Services {
  constructor() {
    super()
    this.resource = 'catalogos'
  }

  async searchClientes(params) {
    try {
      const response = await this._http.get('/clientes', { params })
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async listCatalogs(params) {
    try {
      const response = await this._http.get(`${this.resource}`, { params })
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async getCatalogDetails(hashid) {
    try {
      const response = await this._http.get(
        `${this.resource}/${hashid}/detalhes`
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async resendCatalogEmail(hashid, id) {
    try {
      const response = await this._http.post(
        `${this.resource}/${hashid}/emails/${id}/reenviar`
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async toggleValid(hashid) {
    try {
      const response = await this._http.patch(
        `${this.resource}/${hashid}/toggle-valid`
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async generateLink(payload) {
    try {
      const response = await this._http.post(
        `${this.resource}/generate-link`,
        { ...payload }
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async getPublicCatalog(hashid) {
    try {
      const response = await this._http.get(
        `${this.resource}/public/${hashid}`
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async getPublicCatalogItems(hashid, params) {
    try {
      const response = await this._http.get(
        `${this.resource}/public/${hashid}/items`,
        { params }
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async getPublicCatalogCart(hashid) {
    try {
      const response = await this._http.get(
        `${this.resource}/public/${hashid}/cart`
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async savePublicCatalogCart(hashid, payload) {
    try {
      const response = await this._http.put(
        `${this.resource}/public/${hashid}/cart`,
        payload
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  // `email` e o endereco opcional que o cliente digitou no checkout (#41). Vai
  // vazio quando ele nao preencheu: o backend trata ausencia e string vazia do
  // mesmo jeito, e ainda ha o e-mail cadastrado do cliente no ERP.
  // `tipoLiberacao` e a forma de pagamento declarada (#63); ausente, o backend
  // grava Indefinido (0).
  async finishPublicCatalogOrder(hashid, email = '', tipoLiberacao = 0) {
    try {
      const response = await this._http.post(
        `${this.resource}/public/${hashid}/orcamento`,
        { hashid, email, tipoLiberacao }
      )
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }
}

export default new CatalogoService()